import { render, staticRenderFns } from "./MonthBlocks.vue?vue&type=template&id=01bb5cec"
import script from "./MonthBlocks.vue?vue&type=script&lang=js"
export * from "./MonthBlocks.vue?vue&type=script&lang=js"
import style0 from "./MonthBlocks.vue?vue&type=style&index=0&id=01bb5cec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports